import {
  DdqProdOpsTaskKind,
  DdqProdOpsTaskState,
  DdqProdOpsWizardStep,
  DdqProdOpsWorkflowStatus,
  DdqProdOpsWorkflowType,
  QuestionType,
} from "~/graphql/supergraphEnums";

// "Not started" rather than "Pending": operators read it as work not yet picked up.
export const STATUS_LABELS: Record<DdqProdOpsWorkflowStatus, string> = {
  [DdqProdOpsWorkflowStatus.Pending]: "Not started",
  [DdqProdOpsWorkflowStatus.InProgress]: "In progress",
  [DdqProdOpsWorkflowStatus.InReview]: "In review",
  [DdqProdOpsWorkflowStatus.OnHold]: "On hold",
  [DdqProdOpsWorkflowStatus.Completed]: "Completed",
  [DdqProdOpsWorkflowStatus.Cancelled]: "Cancelled",
};

export const WORKFLOW_TYPE_LABELS: Record<DdqProdOpsWorkflowType, string> = {
  [DdqProdOpsWorkflowType.DdqRequest]: "DDQ request",
  [DdqProdOpsWorkflowType.OriginalFormat]: "Original format",
  [DdqProdOpsWorkflowType.BackfillDdq]: "Backfill DDQ",
};

export const TASK_KIND_LABELS: Record<DdqProdOpsTaskKind, string> = {
  [DdqProdOpsTaskKind.Process]: "Process DDQ",
  [DdqProdOpsTaskKind.Review]: "Review for GP submission",
};

export const TASK_STATE_LABELS: Record<DdqProdOpsTaskState, string> = {
  [DdqProdOpsTaskState.Pending]: "Not started",
  [DdqProdOpsTaskState.InProgress]: "In progress",
  [DdqProdOpsTaskState.Done]: "Done",
};

// Unsettled copy: step 2 is "Generate first draft", not "Run AI Job"/"Run first pass".
export const WIZARD_STEP_LABELS: Record<DdqProdOpsWizardStep, string> = {
  [DdqProdOpsWizardStep.UploadPdf]: "Convert to PDF",
  [DdqProdOpsWizardStep.StructureDdq]: "Structure DDQ",
  [DdqProdOpsWizardStep.GenerateFirstDraft]: "Generate first draft",
};

export const QUESTION_TYPE_LABELS: Record<QuestionType, string> = {
  [QuestionType.YesNo]: "Yes/No",
  [QuestionType.Text]: "Paragraph",
  [QuestionType.Checkbox]: "Checkboxes",
  [QuestionType.MultipleChoice]: "Multiple choice",
  [QuestionType.Table]: "Table",
  [QuestionType.Attachment]: "Attachment",
};

// RESTART_ACTION_LABEL is shared by the overflow menu slot and the footer's primary button.
export const HOLD_ACTION_LABEL = "Put DDQ on hold";
export const RESTART_ACTION_LABEL = "Restart request";
export const CANCEL_ACTION_LABEL = "Cancel DDQ";
